function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "medium",
  transform: "translate(-1119 -85)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4",
  "data-name": "Path 4",
  d: "M0,0H227.531V227.531H0ZM52.371,71.1A5.921,5.921,0,0,1,54.3,76.095v67.559a7.774,7.774,0,0,1-2.069,6.706L36.172,169.836V172.4H81.7v-2.569L65.644,150.36a8.059,8.059,0,0,1-2.212-6.706V85.227L103.393,172.4h4.638l34.325-87.178v69.486c0,1.854,0,2.211-1.213,3.424L128.8,170.122v2.568H188.74v-2.568l-11.917-11.7A3.567,3.567,0,0,1,175.467,155V69.032a3.567,3.567,0,0,1,1.356-3.424l12.2-11.7V51.34H146.78l-30.114,75.121L82.413,51.34H38.1v2.568Z",
  transform: "translate(1119 85)",
  fill: "#f9855b",
  fillRule: "evenodd"
}));

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 227.531,
    height: 227.531,
    viewBox: "0 0 227.531 227.531",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.007c378d.svg";
export { ForwardRef as ReactComponent };